import React from 'react';
import { Link, graphql, StaticQuery } from "gatsby";

export default function HeroNavBarWithData(props) {
  return (
    <StaticQuery
      query={graphql`
        query {
          site {
            siteMetadata {
              loginLink,
              signupLink
            }
          }
        }
      `}
      render={data => <HeroNavBar data={data} {...props} />}
    />
  )
}

const HeroNavBar = ({ data }) => {
  const navLinkClass = 'f6 fw4 hover-white no-underline white-90 dib-ns pv2 ph3';
  const navButtonClass =
    'f6 fw4 hover-white no-underline tc dib ml2 pv2 ph3 mt2 ba b--light-red light-red';

  return (
    <header>
      <div
        className="cover bg-center"
        style={{ backgroundImage: 'url(/img/main_hero_smoothie_exchange.jpg)' }}
      >
        <div className="bg-black-40 pb5 pb6-m pb7-l">
          <nav className="db dt-l w-100 mw8 center">
            <div className="db dtc-l w4 center v-mid pa3 tc">
              <Link to="/" className="pa1 pointer">
                <img src="/img/header-logo-w.png" className=" mb0" alt="O3" />
              </Link>
            </div>
            <div className="db dtc-l v-mid tr-l tc pa3-l">
              <Link to="/outreach/features/" className={navLinkClass}>
                Features
              </Link>
              <Link to="/outreach/pricing/" className={navLinkClass}>
                Pricing
              </Link>
              <Link to="/blog/" className={navLinkClass}>
                Blog
              </Link>
              <a href={data.site.siteMetadata.loginLink} className={navLinkClass}>
                Log In
              </a>
              <Link to="/request-a-demo/" className={navButtonClass}>
                Request a Demo
              </Link>
            </div>
          </nav>
          <div className="tc-l mt4 mt5-m mt6-l ph3">
            <h1
              className="f2 f1-l fw2 white-90 mb0 pt6-l lh-title mw7 center"
              style={{ fontWeight: 400, fontFamily: 'Tofino Regular' }}
            >
              Bring one-on-one relationships back into your business
            </h1>
            <h2
              className="fw1 f3 white-80 mt3 mb4 mw7 center"
              style={{ fontWeight: 400, fontFamily: 'Tofino Regular' }}
            >
              Automated text messages tap into what your customers really think.
            </h2>
            <Link
              className="f5 no-underline grow dib v-mid white ttu tracked-mega ph4 pv3 mb3 mr3"
              to="/outreach/features/"
              style={{ background: '#32a6b4' }}
            >
              Learn More
            </Link>
            <a
              className="f5 no-underline grow dib v-mid white ttu tracked-mega ph4 pv3 mb3 ba bw1 border-box"
              href={data.site.siteMetadata.signupLink}
              style={{ borderColor: '#32a6b4' }}
            >
              Sign Up Now
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};
